import Stack from '@/lib/contentstack/stack';

const fetchEntryData = async (contentTypeUid, entryUid) => {
  try {
    const query = Stack.ContentType(contentTypeUid)
      .Entry(entryUid)
      .addParam('include_dimension', 'true');
    const entry = await query.toJSON().fetch();

    return entry;
  } catch (error) {
    console.error('Error fetching entry:', error);

    return null;
  }
};

function escapeHtmlAttribute(value) {
  if (value === null || value === undefined) {
    return '';
  }

  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

export function stringifyMap(map) {
  return Array.from(map.entries())
    .map(([key, value]) => `${key}="${escapeHtmlAttribute(value)}"`)
    .join(' ');
}

export function htmlStringToNodeArray(str) {
  if (!str) return [];
  const htmlArr = [];
  let currentIndex = 0;

  while (currentIndex < str.length) {
    if (str[currentIndex] === '<') {
      const tagStart = currentIndex;
      const tagEnd = str.indexOf('>', tagStart);
      const openTag = str.slice(tagStart, tagEnd + 1);
      htmlArr.push(openTag);
      currentIndex = tagEnd;
    } else {
      const textStart = currentIndex;
      const textEnd = str.indexOf('<', textStart);
      const text = str.slice(textStart, textEnd);
      htmlArr.push(text);
      currentIndex = textEnd - 1;
    }
    currentIndex++;
  }

  return htmlArr;
}

export function removeParagraphsInsideLists(htmlString) {
  const replaced = htmlString.replace(
    /<li>(?:<p>(.*?)<\/p>)+<\/li>/g,
    '<li>$1</li>',
  );

  return replaced;
}

export { slugToTitle } from './string';
